import { useCallback, useSyncExternalStore } from "react";

export const MD = "(min-width: 768px)";
export const LG = "(min-width: 1024px)";

// Desktop is the default when matchMedia is missing (jsdom, old browsers).
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (notify: () => void) => {
      if (typeof window.matchMedia !== "function") return () => {};
      const mql = window.matchMedia(query);
      mql.addEventListener("change", notify);
      return () => mql.removeEventListener("change", notify);
    },
    [query],
  );
  return useSyncExternalStore(
    subscribe,
    () => (typeof window.matchMedia === "function" ? window.matchMedia(query).matches : true),
    () => true,
  );
}
